export default {
    actions: {},
    mutations: {
        setMobileMenuActive(state) {
            state.activeItems.mobileMenuActive = true
        },
        setMobileMenuNotActive(state) {
            state.activeItems.mobileMenuActive = false
        },
        toggleSearchActive(state) {
            this.commit('restoreActiveItems', 'search');
            state.activeItems.search = !state.activeItems.search;
        },
        toggleMobileOptionsActive(state) {
            state.activeItems.mobileOptions = !state.activeItems.mobileOptions;
        },
        openMobileOptions(state) {
            state.activeItems.mobileOptions = true;
        },
        closeMobileOptions(state) {
            state.activeItems.mobileOptions = false;
        },
        toggleProfileActive(state) {
            state.activeItems.profile = !state.activeItems.profile;
        },
        openProfile(state) {
            state.activeItems.profile = true;
        },
        closeProfile(state) {
            state.activeItems.profile = false;
        },
        openNotifications(state) {
            state.activeItems.notifications = true;
        },
        closeNotifications(state) {
            state.activeItems.notifications = false;
        },
        toggleNotificationsActive(state) {
            state.activeItems.notifications = !state.activeItems.notifications;
        },
        setFilterActive(state) {
            this.commit('restoreActiveItems', 'filter');
            state.activeItems.filter = true;
        },
        setFilterNotActive(state) {
            state.activeItems.filter = false;
        },
        setSearchActive(state) {
            this.commit('restoreActiveItems', 'search');
            state.activeItems.search = true;
        },
        setSearchNotActive(state) {
            state.activeItems.search = false;
        },
        restoreActiveItems(state, payload) {
            let items = {};
            for (const key in state.activeItems) {
                if (key === payload)
                    continue;
                items[key] = false;
            }
            state.activeItems = {...state.activeItems, ...items};
        }
    },
    state: {
        activeItems: {
            mobileMenuActive: false,
            search: false,
            filter: false,
            mobileOptions: false,
            profile: false,
            notifications: false
        }
    },
    getters: {
        mobileMenuActive(state) {
            return state.activeItems.mobileMenuActive
        },
        searchActive(state) {
            return state.activeItems.search
        },
        filterActive(state) {
            return state.activeItems.filter
        },
        mobileOptionsActive(state) {
            return state.activeItems.mobileOptions
        },
        profileActive(state) {
            return state.activeItems.profile
        },
        notificationsActive(state) {
            return state.activeItems.notifications
        },
    }
}
